import factory from '../transactions/position-transactions-factory';
import CashTransactionsHeader from './cash-transactions-header';
import CashTransaction from './cash-transaction';

export default factory({
  assetCategory: 'cash',

  HeaderComponent: CashTransactionsHeader,
  RowComponent: CashTransaction,
});
